exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".adjustment-left{left:0}.commission-info{display:-ms-flexbox;display:flex;margin-right:-15px;margin-left:-15px}.commission-currency{padding-right:15px;padding-left:15px}.adjustment-description{padding-left:15px;font-size:1.25rem}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/payment-modifier-display-calculation/payment-modifier-display.component.css"],"names":[],"mappings":"AAAA,iBACE,MAAQ,CACT,iBAGC,oBAAA,aAAc,mBACM,iBACD,CACpB,qBAGC,mBAAoB,iBACD,CACpB,wBAGC,kBAAmB,iBACA,CACpB","file":"payment-modifier-display.component.css","sourcesContent":[".adjustment-left {\n  left: 0;\n}\n\n.commission-info {\n  display: flex;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.commission-currency {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.adjustment-description {\n  padding-left: 15px;\n  font-size: 1.25rem;\n}\n\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/payment-modifier-display-calculation/payment-modifier-display.component.css
// module id = 3aW+
// module chunks = 0